import React from 'react';
import { Product, CompareProductField } from '@benzinga/content-manager';
import { BzImage } from '@benzinga/image';
import { ProductFeatures } from '../Product/ProductFeatures';
import { SmartLink } from '@benzinga/analytics';
import { Button, Icon } from '@benzinga/core-ui';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import styled from '@benzinga/themetron';

interface CompareProductTableRowProps {
  currentComparingProducts: Product[];
  productFields: CompareProductField[];
}

export const CompareProductTableRow: React.FC<CompareProductTableRowProps> = ({
  currentComparingProducts,
  productFields,
}) => {
  const getProductDetailByKey = (fieldkey, product, fieldType, subfield, fieldLabel = '') => {
    if (product[fieldkey] != null && product[fieldkey] != '') {
      if (fieldType == 'image') {
        return <BzImage height={160} src={product[fieldkey]} width={320} />;
      } else if (fieldType == 'link') {
        return (
          <Button className="compare-button-wrap" size="lg" variant="flat-blue">
            <SmartLink href={product[fieldkey]} label="Compare Product Card">
              <span>
                {fieldLabel} {product['company_name'] != null && `with ${product['company_name']}`}
              </span>
            </SmartLink>
          </Button>
        );
      } else if (fieldType == 'pros' || fieldType == 'cons') {
        return (
          <ProductFeatures
            className="middle-section"
            enableToggle={true}
            features={product[fieldkey][subfield]}
            hideTitle={true}
            key={product.id}
            type={fieldType}
          />
        );
      } else if (fieldType == 'reviewLink') {
        return (
          <SmartLink href={product[fieldkey]} label="Compare Product Card Review">
            <span>
              {product.name} Review <Icon className="inline-block text-[14px] ml-1" icon={faArrowUpRightFromSquare} />
            </span>
          </SmartLink>
        );
      }
    }
    return product[fieldkey];
  };

  return (
    <>
      {Object.keys(productFields).map(key => {
        const fKey = productFields[key].fieldKey;
        const fieldType = productFields[key].type;
        const subfield = productFields[key].subfield;
        const fieldLabel = productFields[key].label;
        const hideLabel = productFields[key]?.hideLabel ?? false;
        return (
          <CompareProductTableRowWrapper key={`${fKey}-${fieldType}-product-value`}>
            <td>{!hideLabel && <>{productFields[key].label}</>}</td>

            {currentComparingProducts.map(productItem => {
              return (
                <td key={`${fKey}-${fieldType}-product-value-${productItem.id}`}>
                  {getProductDetailByKey(fKey, productItem, fieldType, subfield, fieldLabel)}
                </td>
              );
            })}
          </CompareProductTableRowWrapper>
        );
      })}
    </>
  );
};

const CompareProductTableRowWrapper = styled.tr`
  .compare-button-wrap {
    display: block;
    padding: 0 8px;
    a {
      font-size: 14px;
      color: white;
    }
  }
`;
